import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook personalizado para manejar transiciones entre páginas
 * Agrega clases de animación al cambiar de ruta
 */
const usePageTransition = () => {
  const location = useLocation();

  useEffect(() => {
    // Al cambiar de ruta, agrega la clase de salida
    document.body.classList.add('page-exit');
    
    // Después de un breve retraso, elimina la clase de salida y agrega la de entrada
    const timeout = setTimeout(() => {
      document.body.classList.remove('page-exit');
      document.body.classList.add('page-enter');
      
      // Elimina la clase de entrada después de completar la animación
      const enterTimeout = setTimeout(() => {
        document.body.classList.remove('page-enter');
      }, 500);
      
      return () => clearTimeout(enterTimeout);
    }, 300);
    
    return () => clearTimeout(timeout);
  }, [location.pathname]);

  // También podemos manejar el desplazamiento a la parte superior de la página al cambiar de ruta
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

export default usePageTransition;
